/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{Uniform as r}from"./Uniform.js";import{BindType as e}from"../shaderTechnique/BindType.js";class s extends r{constructor(r,s){super(r,"sampler2D",e.Pass,((e,o,t)=>e.bindTexture(r,s(o,t))))}}export{s as Texture2DPassUniform};
